export const searchForm = "s122aox1";
export const searchField = "s1j95he";
export const searchInput = "s1mqvsxx";
export const reset = "rsmt82w";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");